import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as Request from "../../entries/common/request";
import { BaseApi } from "../../core/base-api";
import { makeMethod, makeDataMethod } from "../../core/base-api/methods-maker";
export var MeWatchLaterApi = /*#__PURE__*/function (_BaseApi) {
  _inherits(MeWatchLaterApi, _BaseApi);

  var _super = _createSuper(MeWatchLaterApi);

  function MeWatchLaterApi() {
    _classCallCheck(this, MeWatchLaterApi);

    return _super.apply(this, arguments);
  }

  return MeWatchLaterApi;
}(BaseApi);
/**
 * paged list of videos in user's watch later queue
 */

MeWatchLaterApi.prototype.listVideos = makeMethod({
  method: 'get',
  path: Request.Me.WatchLater.Paths.ListVideos,
  needAuth: true
});
/**
 * add video to watch later queue.
 */

MeWatchLaterApi.prototype.addVideo = makeDataMethod({
  method: 'put',
  path: Request.Me.WatchLater.Paths.AddVideo,
  needAuth: true
});
/**
 * remove video from watch later queue
 */

MeWatchLaterApi.prototype.removeVideo = makeMethod({
  method: 'delete',
  path: Request.Me.WatchLater.Paths.RemoveVideo,
  needAuth: true
});
/**
 * find out number of unwatched videos in watch later queue
 */

MeWatchLaterApi.prototype.getVideoCount = makeMethod({
  method: 'get',
  path: Request.Me.WatchLater.Paths.GetVideoCount,
  needAuth: true
});